import React, { useCallback, useEffect, useState } from 'react';
import ReactSpeedometer from 'react-d3-speedometer';

import { useTheme } from '@material-ui/core/styles';

import { Layout } from '../../../components';
import TabPanel from '../../../components/Tab/TabPanel';
import api from '../../../services/api';
import { EndpointsAPI } from '../../../services/Endpoints';
import Graficos from './Graficos';
import RelatorioAnalitico from './RelatorioAnalitico';
import RelatorioSintetico from './RelatorioSintetico';
import { TabBase, TabsBase, GaugeWrapper, Box, WrapperTab } from './styles';

function a11yProps(index: any) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

interface GaugeProps {
  tempoMinimo: number;
  tempoMedio: any;
  tempoMaximo: number;
}

const Dashboard: React.FC = () => {
  const [value, setValue] = useState(0);
  const theme = useTheme();
  const [gaugeMedia, setGaugeMedia] = useState<GaugeProps>();
  const [gaugeComplete, setGaugeComplete] = useState<GaugeProps>();

  const handleChange = (event: any, newValue: any) => {
    setValue(newValue);
  };

  const fetchGaugeMedia = useCallback(async () => {
    const { data } = await api.get(EndpointsAPI.odometroConveniosSucesso);

    setGaugeMedia(data);
  }, []);

  const fetchGaugeComplete = useCallback(async () => {
    const { data } = await api.get(EndpointsAPI.odometroConvenios);

    setGaugeComplete(data);
  }, []);

  function secondsToDhms(seconds: any) {
    seconds = Number(seconds);
    let d = Math.floor(seconds / (3600 * 24));

    let dDisplay = d;
    return dDisplay;
  }

  useEffect(() => {
    fetchGaugeComplete();
    fetchGaugeMedia();
  }, []);

  return (
    <Layout title={'Dashboard de Convênios'} titlePage={'Dashboard'}>
      <GaugeWrapper>
        <div>
          <label>Tempo de processamento com sucesso</label>
          <Box style={{ paddingTop: '1rem' }}>
            <div style={{ height: '170px' }}>
              {gaugeMedia?.tempoMaximo !== undefined && (
                <>
                  <div style={{ marginTop: '-1.5rem' }}>
                    <label className={'min'}>
                      {gaugeMedia?.tempoMinimo} seg
                    </label>
                    <label className={'media'}>média</label>
                    <label className={'max'}>
                      {gaugeMedia?.tempoMaximo} seg
                    </label>
                    <ReactSpeedometer
                      minValue={gaugeMedia?.tempoMinimo}
                      maxValue={gaugeMedia?.tempoMaximo}
                      value={gaugeMedia?.tempoMedio.toFixed(2)}
                      needleHeightRatio={0.4}
                      ringWidth={56}
                      needleColor="#D9D9D9"
                      segments={3}
                      segmentColors={['#166649', '#AB934B', '#910F2D']}
                      maxSegmentLabels={0}
                      currentValueText={`#{value} seg`}
                      currentValuePlaceholderStyle={`#{value}`}
                    />
                  </div>
                </>
              )}
            </div>
          </Box>
        </div>
        <div>
          <label>Tempo de homologação completo</label>
          <Box style={{ paddingTop: '1rem' }}>
            <div style={{ height: '170px' }}>
              {gaugeComplete?.tempoMaximo !== undefined && (
                <>
                  <div style={{ marginTop: '-1.5rem' }}>
                    <label className={'min'}>
                      {secondsToDhms(gaugeComplete?.tempoMinimo) > 1
                        ? secondsToDhms(gaugeComplete?.tempoMinimo) + ' dias'
                        : secondsToDhms(gaugeComplete?.tempoMinimo) + ' dia'}
                    </label>
                    <label className={'media'}>média</label>
                    <label className={'max'}>
                      {secondsToDhms(gaugeComplete?.tempoMaximo) > 1
                        ? secondsToDhms(gaugeComplete?.tempoMaximo) + ' dias'
                        : secondsToDhms(gaugeComplete?.tempoMaximo) + ' dia'}
                    </label>
                    <ReactSpeedometer
                      minValue={
                        secondsToDhms(gaugeComplete?.tempoMinimo) as number
                      }
                      maxValue={
                        secondsToDhms(gaugeComplete?.tempoMaximo) as number
                      }
                      value={secondsToDhms(gaugeComplete?.tempoMedio) as number}
                      needleHeightRatio={0.4}
                      ringWidth={56}
                      needleColor="#D9D9D9"
                      segments={3}
                      segmentColors={['#166649', '#AB934B', '#910F2D']}
                      maxSegmentLabels={0}
                      currentValueText={`#{value} Dias`}
                      currentValuePlaceholderStyle={`#{value}`}
                    />
                  </div>
                </>
              )}
            </div>
          </Box>
        </div>
      </GaugeWrapper>

      <TabsBase value={value} onChange={handleChange} aria-label="DASHBOARD">
        <TabBase label="RELATÓRIO GERAL" {...a11yProps(0)} />
        <TabBase label="RELATÓRIO ANALÍTICO" {...a11yProps(1)} />
        <TabBase label="GRÁFICOS" {...a11yProps(2)} />
      </TabsBase>

      <WrapperTab>
        <TabPanel value={value} index={0} dir={theme.direction}>
          <RelatorioSintetico />
        </TabPanel>
        <TabPanel value={value} index={1} dir={theme.direction}>
          <RelatorioAnalitico />
        </TabPanel>
        <TabPanel value={value} index={2} dir={theme.direction}>
          <Graficos />
        </TabPanel>
      </WrapperTab>
    </Layout>
  );
};

export default Dashboard;
